import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { TextValidationField } from "../fields/TextField";
import { emailUsernameValidator, usernameValidator } from "./UsernameValidator";
import PropTypes from "prop-types";

export const UsernameEntry = (props) => {
  const { enforceEmailRequirement, ...textFieldProps } = props;
  const emailRequiredForLogin = useSelector(state => state.loginForm.emailRequiredForLogin);
  const requireEmail = enforceEmailRequirement ?? emailRequiredForLogin;
  const validator = requireEmail ? emailUsernameValidator : usernameValidator;

  const label = requireEmail
    ? <FormattedMessage id="login.email" defaultMessage="Email" description="Login form email input label when email is required for login" />
    : <FormattedMessage id="login.userIdOrEmail" defaultMessage="User ID / Email" description="Login form user ID or email input label" />;

  return (
    <TextValidationField
      label={label}
      name="userId"
      validator={validator}
      {...textFieldProps}
    />
  );
};


UsernameEntry.propTypes = {
  onChange: PropTypes.func,
  externalValue: PropTypes.string,
  enforceEmailRequirement: PropTypes.bool,
};

